import { breakpoints } from 'hfs-common-ui';
import useMediaQuery from '~/hooks/use-media-query';

const useIsMobileView = () => {
  return useMediaQuery(`(max-width: ${breakpoints.s}px)`);
};

export default useIsMobileView;
